import { render, staticRenderFns } from "./RevenueCategoriesTable.vue?vue&type=template&id=2c1d575a&scoped=true&"
import script from "./RevenueCategoriesTable.vue?vue&type=script&lang=js&"
export * from "./RevenueCategoriesTable.vue?vue&type=script&lang=js&"
import style0 from "./RevenueCategoriesTable.vue?vue&type=style&index=0&id=2c1d575a&lang=scss&scoped=true&"
import style1 from "./RevenueCategoriesTable.vue?vue&type=style&index=1&lang=css&"
import style2 from "./RevenueCategoriesTable.vue?vue&type=style&index=2&id=2c1d575a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d575a",
  null
  
)

export default component.exports